import {fabric} from 'fabric';
import DefaultSquare from '../nuclide/levelhelpers/DefaultSquare';
import RowColSquare from '../nuclide/levelhelpers/RowColSquare'
import ElementSquare from '../nuclide/levelhelpers/ElementSquare';
import SquareGrid from '../nuclide/levelhelpers/SquareGrid';
import store from '../../store/ReduxStore';

export default function createSeven(nuclide, nuclideData) {
    let items = [];

    if(nuclide.isRow) {
        new RowColSquare(nuclide, items, 128, true, 'Z');
    } else if(nuclide.isColumn) {
        new RowColSquare(nuclide, items, 128, true, 'N');
    } else {
        let square = new DefaultSquare(nuclide, items, 128);

        if (nuclide.location === 'element') {
            let element = new ElementSquare(nuclide, items, 128);
            element.addElementName();

            if (store.getState().dataDisplay.addMass.display) {
                element.addMass(16, 3);
            }

            element.addSymbol();
        } else if (nuclide.location !== 'empty') {
            square.addBlackBand();
            square.addName();
            let grid = new SquareGrid(items, nuclide, 128, nuclideData);
            grid.createGrid(7);
        }

    }

    let group = new fabric.Group(items, {
        objectCaching: false,
        opacity: nuclide.opacity
    });

    return group;
}
